import CallToAction from 'app/frontend/base/components/CallToAction'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'
import { useTeam } from 'app/frontend/base/config/context/team'

interface Props {
  dismissible?: boolean
}

const RcLootCouncilCta = ({ dismissible = true }: Props) => {
  const { team } = useTeam()

  return (
    <ProtectedContent
      key={team.id}
      section='roster'
      requirement='admin'
      teamReference={team}
      renderUnauthorized={false}
    >
      <CallToAction
        title='RCLootCouncil integration'
        uid='rclootcouncil-addon'
        dismissible={dismissible}
        actions={[
          {
            label: 'Get on CurseForge',
            href: 'https://curseforge.com/wow/addons/rclootcouncil-wowaudit',
          },
          {
            label: 'Get on Wago',
            href: 'https://addons.wago.io/addons/rclootcouncil-wowaudit',
          },
        ]}
      >
        You can view your wishlist data directly in-game with the wowaudit
        plugin for RCLootCouncil, in combination with the{' '}
        <a
          href='/desktop'
          target='_blank'
          rel='noreferrer'
          className='text-primary hover:text-primary/90'
        >
          desktop client
        </a>
        . Loot history will also be synchronised back.
      </CallToAction>
    </ProtectedContent>
  )
}

export default RcLootCouncilCta
